export default function LoadingIndicator() {
  return (
    <div className="flex flex-col items-center justify-center h-screen m-auto">
      <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-green-700"></div>
    </div>
  );
}
